import { Text, View, type ViewStyle, type StyleProp } from 'react-native';

import { colors, radius, typography } from '@/theme/tokens';

type Tone = 'magenta' | 'success' | 'warning' | 'danger' | 'neutral' | 'info';

interface Props {
  label: string;
  tone?: Tone;
  size?: 'sm' | 'md';
  style?: StyleProp<ViewStyle>;
  iconLeft?: React.ReactNode;
}

const PALETTE: Record<Tone, { bg: string; fg: string }> = {
  magenta: { bg: colors.magenta[100], fg: colors.magenta[800] },
  success: { bg: colors.success[50], fg: colors.success[600] },
  warning: { bg: colors.warning[50], fg: colors.warning[600] },
  danger: { bg: colors.danger[50], fg: colors.danger[600] },
  neutral: { bg: colors.ink[100], fg: colors.ink[700] },
  info: { bg: '#E0F2FE', fg: '#0369A1' },
};

export function Badge({ label, tone = 'magenta', size = 'sm', style, iconLeft }: Props) {
  const p = PALETTE[tone];
  return (
    <View
      style={[
        {
          flexDirection: 'row',
          alignItems: 'center',
          gap: 6,
          backgroundColor: p.bg,
          paddingHorizontal: size === 'sm' ? 10 : 12,
          paddingVertical: size === 'sm' ? 4 : 6,
          borderRadius: radius.full,
          alignSelf: 'flex-start',
        },
        style,
      ]}
    >
      {iconLeft}
      <Text
        style={{
          color: p.fg,
          fontSize: size === 'sm' ? 11 : 12,
          fontWeight: typography.weights.bold,
          letterSpacing: 0.4,
          textTransform: 'uppercase',
        }}
      >
        {label}
      </Text>
    </View>
  );
}
